import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Cabinet.scss";
import SBooks from "./SBooks";
import SLists from "./SLists";
import PersonalData from "./PersonalData";
import Offline from "./Offline";
import { IoCloseCircle } from "react-icons/io5";
import { useOffline } from "../../contexts/OfflineContext";

const Cabinet = (props: any) => {
  const navigate = useNavigate();
  const { offlineEnabled } = useOffline();
  const [showOfflineMsg, setShowOfflineMsg] = useState(false);

  const goBack = () => {
    if (ifDeleted) {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  const [numberTab, setNumberTab] = useState(
    Number(localStorage.getItem("tabNumber")) || 0
  );
  const [ifDeleted, setIfDeleted] = useState(false);

  const bookWasDeleted = () => {
    setIfDeleted(true);
  };

  const selectTab = (index: number) => {
    if (offlineEnabled && index !== 3) {
      setShowOfflineMsg(true);
      setTimeout(() => setShowOfflineMsg(false), 3000);
      return;
    }
    setNumberTab(index);
    localStorage.setItem("tabNumber", String(index));
  };

  return (
    <div className="cabinet">
      <div className="cabinet-title">
        <h2 className="">Мій кабінет</h2>
        <IoCloseCircle onClick={goBack} className="cabinet-title-close" />
      </div>
      <div className="cabinet-btns">
        <div
          onClick={() => selectTab(0)}
          className={`tab-title ${numberTab === 0 ? "current" : ""} ${offlineEnabled ? "tab-title--disabled" : ""}`}
        >
          <div>Пісенники</div>
        </div>
        <div
          onClick={() => selectTab(1)}
          className={`tab-title ${numberTab === 1 ? "current" : ""} ${offlineEnabled ? "tab-title--disabled" : ""}`}
        >
          <div>Добірки</div>
        </div>
        <div
          onClick={() => selectTab(2)}
          className={`tab-title ${numberTab === 2 ? "current" : ""} ${offlineEnabled ? "tab-title--disabled" : ""}`}
        >
          <div>П/Дані</div>
        </div>
        <div
          onClick={() => selectTab(3)}
          className={`tab-title ${numberTab === 3 ? "current" : ""}`}
        >
          <div>Офлайн</div>
        </div>
      </div>
      {showOfflineMsg && (
        <div className="cabinet-offline-msg">
          Ви в офлайн режимі. Ця вкладка недоступна.
        </div>
      )}
      <div className="tabs">
        {numberTab === 0 && <SBooks bookWasDeleted={bookWasDeleted} />}
        {numberTab === 1 && <SLists />}
        {numberTab === 2 && <PersonalData />}
        {numberTab === 3 && <Offline />}
      </div>
    </div>
  );
};

export default Cabinet;
